
import { Component, ModelSync, Prop, Vue } from 'nuxt-property-decorator'
import UiDropdown from '~/components/ui/UIDropdown/UiDropdown.vue'
import UiDropdownItem from '~/components/ui/UIDropdown/UiDropdownItem.vue'
import UiDropdownHandle from '~/components/ui/UIDropdown/UiDropdownHandle.vue'

@Component({
  components: {
    UiDropdownHandle,
    UiDropdownItem,
    UiDropdown,
  },
})
export default class ProviderFilter extends Vue {
  @ModelSync('value', 'change', {
    required: true,
    type: Number,
    default: 0,
  })
  selectedOptionId!: number

  @Prop({ required: true, default: () => ([]), type: Array })
  readonly options!: Record<string, any>[]

  get selectedOption () {
    return this.options.find(option => this.selectedOptionId === option.pk)!
  }

  onOptionClick (pk: number) {
    this.selectedOptionId = pk
  }
}
